export const sanitiseId = (id: string) => id.replace(' ', '___');
